import gsap from "gsap";

window.addEventListener("DOMContentLoaded", function () {
  const overlay = document.getElementById("overlay");
  const openBtn = document.getElementById("open-overlay");
  const closeBtn = document.getElementById("close-overlay");

  if (!overlay || !openBtn || !closeBtn) return;

  const tween = gsap.to(overlay, {
    autoAlpha: 1,
    duration: 0.2,
    ease: "none",
  });
  tween.pause();

  openBtn.addEventListener("click", () => tween.play());
  closeBtn.addEventListener("click", () => tween.reverse());
});
